import { SxProps } from "@mui/material";

export const sxTypographyAdvice: SxProps = {
    color: '#5F5F5F',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
}

export const sxTypographyAdviceTitle: SxProps = {
    color: '#383838',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '150%',
}

export const sxTypographyFilterStatus: SxProps = {
    color: '#383838',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '150%',
}

export const sxSelectFilter: SxProps = {
    fontFamily: 'Unimed-Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
}

export const sxSelectFilterMenu: SxProps = {
    display: 'flex',
    padding: '24px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '24px',
    alignSelf: 'stretch',
    borderRadius: '4px',
    border: '1px solid var(--grey-light-light, #EEE)',
    background: 'var(--grey-light-white, #FFF)',
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08)',
}

export const sxScheduleDetailKey: SxProps = {
    color: '#5F5F5F',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '150%',
    height: 'max-content',
    marginRight: 1,
}

export const sxScheduleDetailValueStandard: SxProps = {
    color: '#5F5F5F',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    whiteSpace: 'pre-wrap',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
    marginRight: 1,
}

export const sxScheduleDetailStatusYellow: SxProps = {
    color: '#B25817',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    whiteSpace: 'pre-wrap',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '150%',
    marginRight: 1,
    textTransform: 'capitalize',
}

export const sxScheduleDetailStatusGreen: SxProps = {
    color: '#156D44',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    whiteSpace: 'pre-wrap',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '150%',
    marginRight: 1,
    textTransform: 'capitalize',
}

export const sxScheduleDetailStatusRed: SxProps = {
    color: '#CC3D3D',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    whiteSpace: 'pre-wrap',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '150%',
    marginRight: 1,
    textTransform: 'capitalize',
}

export const sxBoxScheduleDetail: SxProps = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline'
}

export const sxDividerScheduleCard: SxProps = {
    width: '100%',
    height: '1px',
    fill: 'none',
    backgroundColor: '#a5a5a5',
    opacity: '0.4'
}

export const sxButtonScheduleAction: SxProps = {
    borderRadius: '80px',
    height: '44px',
    padding: '24px 32px',
    '@media (max-width: 700px)': {
        width:'stretch',
    },
    '@media (min-width: 900px) and (max-width: 1180px)': {
        width:'stretch',
    }
}

export const sxTypographyTitleModal: SxProps = {
    fontFamily: 'UnimedSans-Bold',
    textAlign: 'center',
    fontSize: '28px',
    marginBottom: '24px'
};
  
export const sxTypographySubTitleModal: SxProps = {
    fontFamily: 'Unimed-Sans',
    color: '#5F5F5F',
    textAlign: 'center',
    marginBottom: '24px'
};

export const sxCloseIconButton: SxProps = {
    position: 'absolute',
    right: '24px',
    top: '24px',
    color: '#383838',
}

export const sxPagination: SxProps = {
    width: 'auto',
    height: '32px',
    background: 'unset',
    color: 'unset',
    fontSize: 'unset',
    fontStyle: 'unset',
    fontWeight: 'unset',
    lineHeight: 'unset',
    position: 'unset',
    button: {
        fontFamily: 'UnimedSans-Bold',
        backgroundColor: '#EEE',
        color: '#5F5F5F'
    }
}

export const sxFilterMenuItem: SxProps = {
    fontFamily:'Unimed-Sans',
    color: 'var(--grey-dark-darkest, #383838)',
    padding: '12px',
}

export const sxModal: SxProps = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '578px',
    width: '85%',
    maxHeight: '100vh',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px',
    gap: '24px',
    overflow: 'auto'
}